import { GuestLiteModel, useGetGuests } from 'api-hooks/guest';
import { Option } from 'baseui/select';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

function transformer(item: GuestLiteModel): Option {
  return {
    id: item.id,
    label: item.name,
  };
}

export interface GuestFilterSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
}

export default function GuestFilterSelectInput(
  props: GuestFilterSelectInputProps,
) {
  const { t } = useTranslation();
  const {
    label = t('common:agent'),
    placeholder = t('common:select_guest'),
    value,
    onSelected,
  } = props;

  const query = useGetGuests({
    params: {
      limit: -1,
    },
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  return (
    <CustomFormControl label={label} noMargin={props.noMargin}>
      <Select
        type="select"
        placeholder={placeholder}
        options={options}
        value={_value}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
      />
    </CustomFormControl>
  );
}
